export default "__VITE_ASSET__08b2ab8f__"